module.exports = __webpack_public_path__ + "static/media/plus.f88e6f27.svg";